export const cleanQueryParams = (queryParams) => {
    const params = new URLSearchParams(queryParams);
    const cleanParams = new URLSearchParams();

    if (params.has('organisation')) {
        cleanParams.append('organisation', params.get('organisation'));
    }
    if (params.has('batch')) {
        cleanParams.append('batch', params.get('batch'));
    }

    return `?${cleanParams.toString()}`;
};


// WEBPACK FOOTER //
// ./src/_helpers/cleanurl.js